import React from "react";
import { css } from "react-emotion";
import styled from "react-emotion";

import { validateUrl } from "helpers";

const container = css`
  position: relative;
  max-height: 50%;
  width: 100%;
  color: black;
  padding: 10px;
`;

const LinksStyle = styled("div")`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
`;

const linkStyle = css`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  flex: 1 1 30%;
  justify-content: center;
`;

const iconStyle = css`
  height: 50px;
  width: 50px;
`;

const SocialMediaLinks = (props) => {
  const { links } = props;

  if (!links) return null;

  return (
    <div className={container}>
      <LinksStyle>
        {links &&
          links.map((link, idx) => {
            const { url, icon, displayName } = link;

            if (url === "") return null;

            return (
              <div className={linkStyle} key={idx}>
                <a href={validateUrl(url)} target="_blank">
                  <img className={iconStyle} src={icon} />
                </a>
              </div>
            );
          })}
      </LinksStyle>
    </div>
  );
};

export default SocialMediaLinks;
